import React, { ReactChild } from 'react';

import { Container, Text, Icon } from './HeaderWithIcon.styles';

type Props = {
  icon: ReactChild;
  text: string;
};

const HeaderWithIcon = (props: Props) => (
  <Container>
    {props.icon ? <Icon>{props.icon}</Icon> : null}
    <Text {...props}>{props.text}</Text>
  </Container>
);

export default HeaderWithIcon;
